<div class="w-100 mt-0 tool-container">
  <h4>Download Handlebar Templates</h4>
  <button
    mat-raised-button
    color="primary"
    class="mx-auto"
    (click)="getHandlebarTemplates()"
  >
    Download
  </button>
  @if (downloadLifeProducts.status) {
    <h4 class="col-12 {{ downloadLifeProducts.statusClass }}">
      {{ downloadLifeProducts.status }}
    </h4>
  }
</div>
